var React = require('react');

function ShareStore (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"C88CDEF1-1A74-4A72-9930-1B4B440D6C59"),React.createElement("path",{"d":"M12.646 3v2.816C10.57 5.891 2 7.282 2 19.98c0 0 3.385-7.7 10.646-7.056v2.995L19 9.459 12.646 3z","stroke":"currentColor","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ShareStore.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = ShareStore;

ShareStore.default = ShareStore;
